
<p-dialog data-html2canvas-ignore="true" [style]="{width:'25vw'}" header="Create Blueberry Ticket" [(visible)]="display"  >
    <div>
        <form>
            <div class="ui-grid ui-grid-responsive ui-fluid">
                <span>Email</span>
                <div class="ui-g">
                    <span class="email-placeholder ui-g-2">
                        <input pInputText placeholder="PUID" autofocus name="fromEmail" [(ngModel)]="fromEmail" maxlength="4"/>
                    </span>
                    <span class="ui-g-6">
                        <label>@eurofins.com</label>                
                    </span>
                </div>
            </div>
            <div class="ui-grid ui-grid-responsive ui-fluid">
                <span>Subject</span>
                <br/>
                <input type="text" pInputText placeholder="Subject" name="subject" [(ngModel)]="subject" maxlength="100"/>
            </div>
            <div class="ui-grid ui-grid-responsive ui-fluid">
                <span>Description</span>
                <br/>
                <textarea pInputTextarea placeholder="Write about your issue" name="description" rows="15" [(ngModel)]="description"></textarea>
            </div>
        </form>
    </div>
    
    <div class="ui-g">
        <span class="ui-g-6">
            <button class="ticketBtn" (click)="screenshot()" pButton icon="pi pi-external-link" label="Take Screenshot"></button>
        </span>
        <span class="ui-g-6">
            <button [disabled]="isDisabled()" class="ticketBtn" type="submit" (click)="submit()" pButton icon="pi pi-external-link" label="Create Ticket"></button>
        </span>
    </div>

</p-dialog>
<ul class="list-unstyled">
    <li class="nav-item">
        <a class="nav-link" (click)="showDialog()" style="color:white; cursor:pointer"
            onMouseOver="this.style.color='#b3e9ff'" onMouseOut="this.style.color='#ffffff'">
            <em class="fa fa-fw fa-ambulance fa-lg"></em>
        </a>
    </li>
</ul>

<div data-html2canvas-ignore="true" [hidden]="!display" class="blockBackground"></div>